module.exports = __webpack_public_path__ + "static/media/Proxima_Nova_Alt_Light.e2602b2f.otf";